import { imageNames } from "@/src/constants/imageConstants.js";
import { entityActions } from "@/src/constants/entityConstants.js";

export const triggerEvents = {
  ENTITY_CREATED: "created",
  ENTITY_UPDATED: "updated",
  ENTITY_DELETED: "deleted",
  TASK_COMPLETED: "marked_done",
};

export const formListHeaders = [
  { label: "Form Name", key: "name", width: 3 },
  { label: "Status", key: "status", width: 2 },
  { label: "Last Updated", key: "last_updated", width: 2 },
];

export const formResponseHeaders = [
  { label: "Submission ID", key: "id", width: 2 },
  { label: "Entity Type", key: "entityType", width: 2 },
  { label: "Entity ID", key: "entityId", width: 2 },
  { label: "Status", key: "status", width: 2 },
  { label: "Submitted At", key: "submittedAt", width: 2 },
];

export const formResponseActions = [
  {
    id: "view",
    name: "View Details",
    icon: imageNames.EYE_GREY,
  },
  {
    id: "edit",
    name: "Edit",
    icon: imageNames.EDIT,
  },
  {
    id: "delete",
    name: "Delete",
    icon: imageNames.DELETE_GREY,
  },
];

export const formBuilderTabs = [
  { id: "forms", title: "Forms" },
  { id: "rules", title: "Rules" },
];

export const formLeftPanelTabs = [
  { id: "components", title: "Components" },
  { id: "properties", title: "Properties" },
];

export const fieldTypes = {
  TEXT: "text",
  EMAIL: "email",
  PHONE: "phone",
  SINGLE_SELECT: "single-select",
  MULTI_SELECT: "multi-select",
  DATE: "date",
  DATETIME: "datetime",
  FILE: "file",
  TEXT_DISPLAY: "text-display",
  IMAGE: "image",
  SECTION: "section",
  TEXTAREA: "textarea",
  NUMBER: "number",
  URL: "url",
  DOMAIN: "domain",
  USER: "user",
  BOOLEAN: "boolean",
  TAGS: "tags",
  FORMULA: "formula",
  PROPERTY_SYNC: "property_sync",
  RELATION_RECORD: "relation_record",
  SELECT_TIMESTAMP: "select_timestamp",
  TIME: "time",
  MEETING_LOG: "meeting-log",
  ENTITY: "entity",
};

export const fieldTypeGroups = {
  TEXT_INPUTS: ["text", "email"],
  SELECT_INPUTS: ["single-select", "multi-select", "user"],
  NO_LABEL_FIELDS: ["text-display", "image", "meeting-log", "entity"],
  DATE_TIME_FIELDS: ["date", "datetime"],
  READ_ONLY_FIELDS: ["formula", "property_sync", "select_timestamp", "relation_record"],
};

export const meetingLogMandatorySubFields = [
  { key: "attendees", label: "Attendees", type: "multi-select", required: true, locked: true },
  { key: "outcome", label: "Outcome", type: "single-select", required: false, locked: true },
  { key: "disposition", label: "Disposition", type: "single-select", required: false, locked: true },
  { key: "date", label: "Date", type: "date", required: true, locked: true },
  { key: "start_time", label: "Start Time", type: "single-select", required: true, locked: true },
  { key: "end_time", label: "End Time", type: "single-select", required: true, locked: true },
  { key: "description", label: "Description", type: "textarea", required: false, locked: true },
  { key: "attachment_ids", label: "Attachments", type: "file", required: false, locked: true },
];

export const defaultSelectOptions = [
  { label: "Option 1", value: "option1" },
  { label: "Option 2", value: "option2" },
];

export const defaultImageField = {
  IMAGE_URL: "",
  ALT_TEXT: "",
  IMAGE_WIDTH: "auto",
  CUSTOM_WIDTH: "",
};

export const attributeTypes = {
  STRING: "string",
  TEXT: "text",
  EMAIL: "email",
  PHONE: "phone",
  PHONE_NUMBER: "phone_number",
  NUMBER: "number",
  INTEGER: "integer",
  FLOAT: "float",
  DECIMAL: "decimal",
  DATE: "date",
  DATETIME: "datetime",
  BOOLEAN: "boolean",
  SELECT: "select",
  MULTISELECT: "multiselect",
  MULTI_SELECT: "multi_select",
  TEXTAREA: "textarea",
  URL: "url",
  DOMAIN: "domain",
  USER: "user",
  RICHTEXT: "richtext",
  CURRENCY: "currency",
  PERCENTAGE: "percentage",
  TAGS: "tags",
  FORMULA: "formula",
  PROPERTY_SYNC: "property_sync",
  RELATION_RECORD: "relation_record",
  SELECT_TIMESTAMP: "select_timestamp",
  TIME: "time",
  FILE: "file",
};

export const attributeTypeToFieldTypeMap = {
  [attributeTypes.STRING]: fieldTypes.TEXT,
  [attributeTypes.TEXT]: fieldTypes.TEXT,
  [attributeTypes.EMAIL]: fieldTypes.EMAIL,
  [attributeTypes.PHONE]: fieldTypes.PHONE,
  [attributeTypes.PHONE_NUMBER]: fieldTypes.PHONE,
  [attributeTypes.NUMBER]: fieldTypes.NUMBER,
  [attributeTypes.INTEGER]: fieldTypes.NUMBER,
  [attributeTypes.FLOAT]: fieldTypes.NUMBER,
  [attributeTypes.DECIMAL]: fieldTypes.NUMBER,
  [attributeTypes.DATE]: fieldTypes.DATE,
  [attributeTypes.DATETIME]: fieldTypes.DATETIME,
  [attributeTypes.BOOLEAN]: fieldTypes.SINGLE_SELECT,
  [attributeTypes.SELECT]: fieldTypes.SINGLE_SELECT,
  [attributeTypes.MULTISELECT]: fieldTypes.MULTI_SELECT,
  [attributeTypes.MULTI_SELECT]: fieldTypes.MULTI_SELECT,
  [attributeTypes.TEXTAREA]: fieldTypes.TEXTAREA,
  [attributeTypes.URL]: fieldTypes.URL,
  [attributeTypes.DOMAIN]: fieldTypes.DOMAIN,
  [attributeTypes.USER]: fieldTypes.USER,
  [attributeTypes.RICHTEXT]: fieldTypes.TEXTAREA,
  [attributeTypes.CURRENCY]: fieldTypes.NUMBER,
  [attributeTypes.PERCENTAGE]: fieldTypes.NUMBER,
  [attributeTypes.TAGS]: fieldTypes.TAGS,
  [attributeTypes.FORMULA]: fieldTypes.FORMULA,
  [attributeTypes.PROPERTY_SYNC]: fieldTypes.PROPERTY_SYNC,
  [attributeTypes.RELATION_RECORD]: fieldTypes.RELATION_RECORD,
  [attributeTypes.SELECT_TIMESTAMP]: fieldTypes.SELECT_TIMESTAMP,
  [attributeTypes.TIME]: fieldTypes.TIME,
  [attributeTypes.FILE]: fieldTypes.FILE,
};

export const formDetailTabs = [
  {
    id: "responses",
    title: "Responses",
    unselected: imageNames.OUTPUT_UNSELECTED,
    selected: imageNames.OUTPUT_SELECTED,
  },
  {
    id: "rules",
    title: "Rules",
    unselected: imageNames.INFO_GREY,
    selected: imageNames.INFO,
  },
];

export const formResponsesActions = {
  EXPORT_AS_CSV: "export_as_csv",
};

export const formResponsesActionOptions = [
  {
    id: formResponsesActions.EXPORT_AS_CSV,
    label: "Export as CSV",
    icon: imageNames.EXPORT_GREY,
    handler: null,
  },
];

export const operatorLabels = {
  equals: "equals",
  not_equals: "not equals",
  contains: "contains",
  does_not_contain: "does not contain",
  starts_with: "starts with",
  ends_with: "ends with",
  is_empty: "is empty",
  is_not_empty: "is not empty",
  greater_than: ">",
  less_than: "<",
  before: "before",
  after: "after",
};

export const actionLabels = {
  show: "Show",
  hide: "Hide",
  make_readonly: "Make Read-only",
  make_mandatory: "Make Mandatory",
};

export const ruleOperators = {
  EQUALS: "equals",
  NOT_EQUALS: "not_equals",
  CONTAINS: "contains",
  DOES_NOT_CONTAIN: "does_not_contain",
  STARTS_WITH: "starts_with",
  ENDS_WITH: "ends_with",
  IS_EMPTY: "is_empty",
  IS_NOT_EMPTY: "is_not_empty",
  GREATER_THAN: "greater_than",
  LESS_THAN: "less_than",
  GREATER_THAN_OR_EQUAL: "greater_than_or_equal",
  LESS_THAN_OR_EQUAL: "less_than_or_equal",
  BETWEEN: "between",
  BEFORE: "before",
  AFTER: "after",
  CONTAINS_ANY: "contains_any",
  CONTAINS_ALL: "contains_all",
  IS: "is",
};

export const ruleActionTypes = {
  SHOW: "show",
  HIDE: "hide",
  MAKE_READONLY: "make_readonly",
  MAKE_MANDATORY: "make_mandatory",
};

export const ruleActionOptions = [
  { id: ruleActionTypes.SHOW, label: "Show" },
  { id: ruleActionTypes.HIDE, label: "Hide" },
  { id: ruleActionTypes.MAKE_READONLY, label: "Make Read-only" },
  { id: ruleActionTypes.MAKE_MANDATORY, label: "Make Mandatory" },
];

export const ruleConditionTypes = {
  FORM: "form",
  PROPERTY: "property",
};

export const ruleConditionOptions = [
  { id: ruleConditionTypes.FORM, label: "Form" },
  { id: ruleConditionTypes.PROPERTY, label: "Property" },
];

export const ruleTriggerTypes = {
  ON_LOAD: "on_load",
  ON_CHANGE: "on_change",
};

export const ruleTriggerOptions = [
  { id: ruleTriggerTypes.ON_LOAD, label: "On Load" },
];

export const ruleEvaluationTypes = {
  ALL: "all",
  ANY: "any",
};

export const ruleEvaluationOptions = [
  { id: ruleEvaluationTypes.ALL, label: "All" },
  { id: ruleEvaluationTypes.ANY, label: "Any" },
];

export const ruleTargetTypeOptions = [
  { id: "property", label: "Property" },
  { id: "section", label: "Section" },
];

export const formRuleOptions = [
  {
    id: entityActions.DUPLICATE,
    label: "Duplicate",
    icon: imageNames.COPY_GREY,
    handler: null,
  },

  {
    id: entityActions.DELETE,
    label: "Delete",
    icon: imageNames.DELETE_GREY,
    handler: null,
  },
];

export const fieldValidationPatterns = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  URL: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
  DOMAIN: /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i,
  PHONE: /^\+?[\d\s\-()]+$/,
};

export const fieldValidationMessages = {
  EMAIL: "Please enter a valid email address",
  URL: "Please enter a valid URL",
  DOMAIN: "Please enter a valid domain",
  PHONE: "Please enter a valid phone number",
  REQUIRED: "This field is required",
};

export const formComponentsList = [
  {
    id: "text_display",
    label: "Text",
    type: "text-display",
    icon: "text",
    placeholder: "",
    required: false,
    description: "",
  },
  {
    id: "text_input",
    label: "Text Input",
    type: "text",
    icon: "text",
    placeholder: "",
    required: false,
  },
  {
    id: "textarea",
    label: "Textarea",
    type: "textarea",
    placeholder: "",
    required: false,
  },
  {
    id: "number_input",
    label: "Number Input",
    type: "number",
    placeholder: "",
    required: false,
  },
  {
    id: "email_input",
    label: "Email ID",
    type: "email",
    placeholder: "",
    required: false,
  },
  {
    id: "phone_input",
    label: "Phone Number",
    type: "phone",
    icon: "phone",
    placeholder: "",
    required: false,
  },
  {
    id: "single_select",
    label: "Single Select",
    type: "single-select",
    icon: "select",
    placeholder: "",
    required: false,
    options: [
      { label: "Option 1", value: "option1" },
      { label: "Option 2", value: "option2" },
    ],
  },
  {
    id: "multi_select",
    label: "Multi Select",
    type: "multi-select",
    icon: "select",
    placeholder: "",
    required: false,
    options: [
      { label: "Option 1", value: "option1" },
      { label: "Option 2", value: "option2" },
    ],
  },
  {
    id: "date_input",
    label: "Date Input",
    type: "date",
    icon: "calendar",
    placeholder: "",
    required: false,
  },
  {
    id: "datetime_input",
    label: "Date Time Input",
    type: "datetime",
    icon: "calendar",
    placeholder: "",
    required: false,
  },
  {
    id: "url_input",
    label: "URL",
    type: "url",
    placeholder: "",
    required: false,
  },
  {
    id: "domain_input",
    label: "Domain",
    type: "domain",
    placeholder: "",
    required: false,
  },
  {
    id: "user_select",
    label: "SuperAGI User",
    type: "user",
    placeholder: "",
    required: false,
  },
  {
    id: "section",
    label: "Section",
    type: "section",
    icon: "section",
    placeholder: "",
    required: false,
    children: [],
  },
  {
    id: "entity_select",
    label: "Entity",
    type: "entity",
    icon: "select",
    placeholder: "Search and select a record...",
    required: false,
    entityConfig: null,
  },
];

export const normalizePhoneValue = (value) => {
  try {
    if (!value) return "";

    if (typeof value === "string") return value;

    if (
      Array.isArray(value) &&
      value.length > 0 &&
      value[0]?.normalized_phone_number
    ) {
      return value[0].normalized_phone_number;
    }

    if (typeof value === "object" && value.normalized_phone_number) {
      return value.normalized_phone_number;
    }

    return String(value);
  } catch (error) {
    console.error("An error occurred while normalizing phone number: ", error);
    return "";
  }
};
